export default {
  description: '{{name}} a {{city}}. Menu ufficiale. Risparmia e ordina online qui.',
};
